/**
 * Technician types representing MSP staff who access customer tenants.
 */
export const TECHNICIAN_TIERS = ["Tier-0", "Tier-1", "Tier-2", "Tier-3", "Tier-4"];
export const SECURITY_CLEARANCES = ["None", "Basic", "NV1", "NV2", "PV"];
export const WORK_LOCATIONS = ["AU", "CA", "EU", "NZ", "PH", "US"];
/**
 * Numeric tier ordering where lower number = higher privilege.
 */
export const TIER_NUMERIC_RANK = {
    "Tier-0": 0,
    "Tier-1": 1,
    "Tier-2": 2,
    "Tier-3": 3,
    "Tier-4": 4,
};
//# sourceMappingURL=technician.js.map